export const units = {
  l: 'Liter',
  kg: 'kg',
}
